<template>
  <div class="margin-t10">
    <van-button
      v-if="$store.getters.point_list_status === '0'"
      type="danger"
      size="small"
      native-type="danger"
      @click="confirm('1')"
    >拒绝</van-button>&nbsp;&nbsp;
    <van-button
      v-if="$store.getters.point_list_status === '0'"
      type="info"
      size="small"
      native-type="submit"
      @click="confirm('2')"
    >同意</van-button>
  </div>
</template>
<script>
import { IpdApprovalStatusMobile } from '@/api/EducationalPoints'
import { Notify } from 'vant'
import { Dialog } from 'vant'
export default {
  name: 'ExamineButton',
  components: {
    [Notify.Component.name]: Notify.Component,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
    }
  },
  created: function() {
  },
  mounted() {
  },
  methods: {
    confirm(flg) {
      Dialog.confirm({
        title: '提示',
        message: '是否确认审批?'
      })
        .then(() => {
          this.determine(flg)
        })
        .catch(() => {
        })
    },
    determine(flg) {
      const that = this
      const array = []
      const parse = {}
      parse.id = this.$parent.data.id
      parse.approval_status = flg
      parse.approval_user_id = this.$store.getters.usercode
      parse.approval_user_name = this.$store.getters.username
      parse.refuse_reason = null
      array.push(parse)
      IpdApprovalStatusMobile(array, function(res) {
        if (res.code === 0) {
          Notify({ type: 'success', message: flg === '1' ? '拒绝成功' : '审批成功', duration: 1000 })
        } else {
          Notify({ type: 'danger', message: flg === '1' ? '拒绝失败' : '审批失败', duration: 1000 })
        }
        that.toApproval()
      })
    },
    toApproval() {
      this.$router.push(
        { path: '/' }
      )
      this.$store.dispatch('pointvuex/point_to', '1')
    },
    Required() {
      // 申请对象
      if (this.$parent.aplicationobject === '') { Notify({ type: 'warning', message: '请填写申请对象!', duration: 1000 }); return false }
      // 小数点不能超过两位
      const r = /^(\d+|\d+\.\d{1,2})$/
      if (!r.test(this.$parent.reimbursementamount)) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能大于可用积分数
      if (parseInt(this.$parent.reimbursementamount) > parseInt(this.$parent.pointSum)) { Notify({ type: 'warning', message: '可用积分不足!', duration: 1500 }); return false }
      // 报销金额不能为0
      if (parseInt(this.$parent.reimbursementamount) === 0) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能小于0
      if (this.$parent.reimbursementamount < 0) { Notify({ type: 'warning', message: '报销金额请输入正数并且小数位不能超过两位!', duration: 1500 }); return false }
      // 报销金额不能为空
      if (this.$parent.reimbursementamount === '') { Notify({ type: 'warning', message: '请填写报销金额!', duration: 1500 }); return false }
      // 申请类型
      if (this.$parent.aplicationtypename === '') { Notify({ type: 'warning', message: '请填写申请类型!', duration: 1500 }); return false }
      // 申请说明
      if (this.$parent.applicationdescription === '') { Notify({ type: 'warning', message: '请填写申请说明!', duration: 1500 }); return false }
      // 审核人
      if (this.$parent.reviewertext === '') { Notify({ type: 'warning', message: '请填写审批人名!', duration: 1500 }); return false }
      return true
    }
  }
}
</script>
<style scoped>
  .margin-t10{
    padding: 15px 8px 0px 8px;
    float: right;
  }
</style>
